import { combineReducers } from "redux";

import dashboard from "../features/admin/dashboard/dashboard/slice";

const dashboards = combineReducers({
  dashboard,
});

export default dashboards;
